import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { durationEditor } from '../../../assets/js/field_config/editor-inline-gantt';
import { columnCache } from '../../../services/columnCache';

const durationCol = (gantt, t) => {
  const name = 'duration';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    name,
    label: t('gantt.columns.duration', 'Duración'), // Assuming translation
    align: 'center',
    width: '80',
    resize: true,
    editor: gantt ? durationEditor(gantt) : null,
    template: (activity) => {
      const cachedResult = columnCache.get('duration', activity.id);
      if (cachedResult !== undefined) {
        return cachedResult;
      }

      const hasChild = gantt.hasChild(activity.id);
      let isOdd = false;
      if (gantt.oddColsConfig) {
        isOdd = gantt.oddColsConfig.duration;
      }

      const duration_content = activity.for_disable_milestone_duration !== 0
        ? gantt.formatter.format(activity.for_disable_milestone_duration)
        : '0 days';

      const result = t('lang') === 'en'
        ? '<div class="' +
            (isOdd ? 'odd-col' : 'non-odd-col') +
            '" style="' +
            (hasChild ? 'font-weight: 600' : 'font-weight: 100') +
            '">' +
            duration_content +
            '</div>'
        : '<div class="' +
            (isOdd ? 'odd-col' : 'non-odd-col') +
            '" style="' +
            (hasChild ? 'font-weight: 600' : 'font-weight: 100') +
            '">' +
            duration_content.replace('.', ',') +
            '</div>';

      columnCache.set('duration', activity.id, result);
      return result;
    },
    hide: !isVisible,
    data_type: 'number',
    groupable: false,
    orderable: false, // Original was false
    orderable_switch: ['1 → 9', '9 → 1'],
    filterable: true,
  };
};

export default durationCol; 